/**
 * FingerprintJS visitorId, computed once per session and cached in-module.
 *
 * Sent to Monosan as `x-fingerprint` header for audit/anti-fraud purposes.
 * Header name is provisional — confirm with the Monosan team before relying
 * on it server-side. Today Monosan's audit headers (see `N26Headers.kt`)
 * include `device-token` and `x-n26-userip` only.
 */
import FingerprintJS, {
  type Agent,
  type GetResult,
} from '@fingerprintjs/fingerprintjs'

let agentPromise: Promise<Agent> | null = null
let cached: string | null = null

const getAgent = (): Promise<Agent> => {
  if (!agentPromise) agentPromise = FingerprintJS.load()
  return agentPromise
}

export const getFingerprint = async (): Promise<string> => {
  if (cached) return cached
  const agent = await getAgent()
  const result: GetResult = await agent.get()
  cached = result.visitorId
  return cached
}

/**
 * Test-only override. Used by `setupTests.ts` to keep tests deterministic.
 */
export const __setFingerprintForTests = (value: string | null): void => {
  cached = value
  agentPromise = null
}
